import { HorizontalBox } from "src/components/common/box/HorizontalBox.tsx";
import { BoxProps } from "@mui/material";
import { mergeSx } from "src/utils/styles.ts";

export interface AavoFormFooterProps extends Omit<BoxProps, "ref"> {}

export const AavoFormFooter = ({ sx, children, ...other }: AavoFormFooterProps) => {
	return (
		<HorizontalBox
			sx={mergeSx(
				{
					backgroundColor: "grey.50",
					borderTop: "1px solid",
					borderTopColor: "divider",
					minHeight: "3rem",
					justifyContent: "flex-end",
					gap: 1,
					paddingX: 1.5,
					"& .MuiTypography-button": {
						textAlign: "center",
					},
				},
				sx,
			)}
			{...other}
		>
			{children}
		</HorizontalBox>
	);
};
